<template>
    <div id="app" class="container-fluid dashboard">
        <legacy-app-notice />
        <div class="row">
            <mainMenu />
            <transition :name="transitionName" mode="out-in">
                <router-view class="view"></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    import mainMenu from './components/menu.vue';
    import legacyAppNotice from './components/legacy-app-notice.vue';

    export default {
        name: 'app',
        data(){
            return {
                transitionName: 'fade',
            }
        },
        components: {
            mainMenu,
            legacyAppNotice,
        },
        watch: {
            '$route' (to, from) {
                if(to.meta.transition){
                    this.transitionName = to.meta.transition;
                }else{
                    this.transitionName = 'fade';
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue